module.exports = __webpack_public_path__ + "img/it.72c30ee7.jpg";